import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useMediaQuery } from 'react-responsive';
import { CommonStyledComponentProps } from '__utils/type';
import { LayoutContext } from 'components/app-routes';
import { propsToJS } from '__utils/immutable-to-js';
import { useDispatch, useSelector } from 'react-redux';
import LoginSelector from 'views/login/login.selector';
import { isProUser, getName, scrollToElementId, gotoKnowMore, addAgentCode } from '__utils/common-utils';
import './index.css';
import { SuccessButton, SuccessBtnWhiteGreenBorder } from 'components/button';
import { Mixpanel, getEventName } from '__utils/mixpanel';
import UserSelector from 'views/user/user.selector';
import { getUserDetails } from '__utils/storage';
import KnowMorePopup from 'views/know-more/know-more-popup';
import { showKnowMoreRegister } from 'views/know-more/know-more-helper';
import { useHistory } from 'react-router-dom';
import { showOrderPopupAction } from 'components/pending-order-popup/pendingOrder.actions';
import PendingOrderPopup from 'components/pending-order-popup';

const BannerBox = styled.div<CommonStyledComponentProps>`
    .mint-head{
        margin-bottom: 0;
        padding: ${(props: CommonStyledComponentProps) => !props.isMobile ? '24px 24px 0 24px' : '16px 16px 0 16px '} ;
        font-size: ${(props: CommonStyledComponentProps) => props.isMobile ? '16px' : '24px'};
    }
    .portfolio-grid{
        margin: ${(props: CommonStyledComponentProps) => props.isMobile ? '16px 0' : '48px 0'};
        p{
            font-size: ${(props: CommonStyledComponentProps) => props.isMobile ? '12px' : '16px'};
        }
        span{
            font-size: ${(props: CommonStyledComponentProps) => props.isMobile ? '14px' : '16px'};
        }
    }
    .card-greyTxt{
        padding: ${(props: CommonStyledComponentProps) => props.isMobile ? '16px' : '24px'};
        small{
            font-size: ${(props: CommonStyledComponentProps) => props.isMobile ? '12px' : '16px'};
        }
    }
    
`;

const HomeBanner: React.FC = () => {

    const history = useHistory();
    const dispatch = useDispatch();
    const isMobile = useMediaQuery({ maxWidth: 767 });
    const [showKnowMorePopup, setShowKnowMorePopup] = useState<boolean>(false);
    const { portfolioDetails } = propsToJS(useSelector(LoginSelector));
    const { isAgentARN, countTotalAUM, paymentUrl } = propsToJS(useSelector(UserSelector));

    // eslint-disable-next-line
    const { layoutProps, SetLayoutProps } = React.useContext(LayoutContext);

    useEffect(() => {
        SetLayoutProps({
            config: { title: 'UPI Payment' },
            showCopyrightInfoForDesktop: true,
        })
    }, []);

    useEffect(() => {
        if (paymentUrl) dispatch(showOrderPopupAction());
    }, [paymentUrl])


    const getBannerHead = () => {
        return isProUser() ?
            'Click now and get a FREE call from our experts to start earning with Mutual Funds' :
            getUserDetails() && portfolioDetails?.netAmountInvested ? `Hi ${getName()},` : paymentUrl ? 'You have an existing order in process.' : 'Start your Investment journey now!'
    }

    const getMFDescription = () => {
        return isProUser() ?
            'Sign up for mutual funds business in two easy clicks & earn more from existing client base.' :
            getUserDetails() && portfolioDetails?.netAmountInvested ? 'Your mutual fund investments are expected to perform better over longer term.' : (!isMobile || (isMobile && !paymentUrl)) && 'Select from a pool of 500+ mutual funds catering to all your financial needs.'
    }

    const onBrowseFundsClick = () => {
        scrollToElementId("Browse");
        Mixpanel.track(getEventName('browseIndividualFunds', 'clicked', 'home'))

    };
    const goToPortfolio = () => {
        Mixpanel.track(getEventName('viewPortfolio', 'clicked', 'home'))
        history.push(addAgentCode("/profile/portfolio"));
    };

    const goToOrderSummary = () => {
        history.push('/order-summary?paymentUrl=' + paymentUrl);
    };

    const registerDp = () => {
        showKnowMoreRegister();
        setShowKnowMorePopup(true);
    }

    const getMFButton = () => {
        return (
            <div className={isMobile ? '' : "mt36"}>
                {isProUser() ?
                    <>
                        <div className="grid-center">
                            {!(isAgentARN || getUserDetails()) && <SuccessButton onClick={registerDp}>I am Interested</SuccessButton>}
                        </div>
                    </>
                    :
                    (getUserDetails() && portfolioDetails?.netAmountInvested) ? <div>
                        <div className="portfolio-grid">
                            <p>Invested sum <br />
                                <span>&#8377; {portfolioDetails?.netAmountInvested?.toLocaleString('en-IN')}</span>
                            </p>
                            <p>Current value <br />
                                <span>&#8377; {portfolioDetails?.netCurrentValue?.toLocaleString('en-IN')}</span>
                            </p>
                            <p>Returns <br />
                                {<b>
                                    <span className={portfolioDetails.netCurrentValue >= portfolioDetails.netAmountInvested ? 'changesUp valueText' : 'changesDown valueText'}> {portfolioDetails.netCurrentValue >= portfolioDetails.netAmountInvested ? '+' : ''} {(portfolioDetails?.netReturnPercentage)?.toFixed(1)}%</span>
                                </b>}
                            </p>
                        </div>

                        <div className="grid-center">
                            {paymentUrl ? <SuccessButton onClick={goToOrderSummary}>Existing Order</SuccessButton> : <SuccessButton onClick={onBrowseFundsClick}>Invest More</SuccessButton>}
                            <SuccessBtnWhiteGreenBorder onClick={goToPortfolio}>Review Portfolio</SuccessBtnWhiteGreenBorder>
                        </div>
                    </div> :
                        <div className={!isMobile ? 'grid-center ' : 'mt16'}>
                            {paymentUrl ? <SuccessButton onClick={goToOrderSummary}>Continue with Existing Order</SuccessButton>
                                : <SuccessButton onClick={onBrowseFundsClick}>Start Investing</SuccessButton>}
                        </div>
                }
            </div>
        )
    }


    return <>
        {(isProUser() && countTotalAUM?.customerCount >= 2 && isMobile) ? null : <BannerBox isMobile={isMobile} >
            <div className={`mint-box mt30 ${isMobile && 'm16'}`}>
                {/* {
                    (isMobile && isProUser() && countTotalAUM?.customerCount < 2) ?
                        <div>
                            <iframe className="km-video" style={{ width: '100%', height: '200px' }}
                                src="https://www.youtube.com/embed/DdOCQFrvjD8"
                                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" >
                            </iframe><br />
                            <p className='p16'><b>Click now and get a FREE call from our experts to start earning with Mutual Funds</b></p>
                        </div>
                        : <p className='mint-head'>{getBannerHead()} </p>
                } */}
                { isMobile && isProUser() && <p className='mint-head'>{getBannerHead()} </p>}
                <div className='card-greyTxt'>
                    {!(isMobile && isProUser() && countTotalAUM?.customerCount < 2) && <small>{getMFDescription()}</small>}
                    <div>{getMFButton()}</div>
                </div>
            </div>
            < PendingOrderPopup />
        </BannerBox>}

        {showKnowMorePopup && <KnowMorePopup onClose={() => setShowKnowMorePopup(false)}  />}

    </>


}
export default HomeBanner;